import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";

const useGetUserToken = () => {
  const [userToken, setUserToken] = useState<string | undefined>(undefined);
  const auth = getAuth();

  // Get user token
  useEffect(() => {
    const getToken = async () => {
      const token = await auth.currentUser?.getIdToken();
      if (token) {
        setUserToken(token);
      }
    };
    getToken();
  }, [auth.currentUser]);

  return userToken;
};

export default useGetUserToken;
